<template>
    <div class="content-container-white">

        <ModuleHeader title="Rechnung erstellen">

        </ModuleHeader>
        <div class="container mt-4">

        <div class="loading" v-if="!customers && !projects && !invoices && !error">

        </div>

        <div v-if="error" class="error">
            <div class="mb-4">{{ error }}</div>
            <button type="button" class="btn btn-primary" @click="$router.go(-1)">Zurück</button>
        </div>

        <div v-if="saveError" class="error">
            <div class="mb-4">{{ saveError }}</div>
            <button type="button" class="btn btn-primary" @click="$router.go(-1)">Zurück</button>
        </div>


        <div v-if="customers && projects && invoices && !saveError && !error" class="row">


            <div class="col-12"><h2 class="form-object-title">Rechnung {{invoice.number}}</h2></div>

            <div class="col-12 mt-4">
            <form @submit.prevent="createInvoice" class="default-form">
                <div class="form-row">
                    <div class="form-group col-md-4">
                        <label for="invoiceNumber">Rechnungsnummer</label>
                        <input type="text" class="form-control" id="invoiceNumber" aria-describedby="invoiceNumberHelp"
                               v-model="invoice.number"
                               autocomplete="off"
                        >
                    </div>
                    <div class="form-group col-md-4">
                        <label for="inputCustomer">Kunde</label>

                        <select id="inputCustomer" class="form-control" v-model="invoice.customerId">
                            <option v-for="customer in customers" v-bind:key="customer.id" v-bind:value="customer.id">{{customer.name}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-4">
                        <label for="inputState">Projekt</label>

                        <select id="inputState" class="form-control" v-model="invoice.project">
                            <option v-for="project in projects.filter(x => x.customerId === invoice.customerId)" v-bind:key="project.id" v-bind:value="project">{{project.name}}</option>
                        </select>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-12">
                        <b-button size="sm" class="mr-1" variant="outline-secondary" @click="openPositionDialog($refs.defaultInvoicePositionDialog)">
                            <font-awesome-icon icon="plus-circle" class="icon mb-1"/> Position erstellen
                        </b-button>
                        <b-button size="sm" variant="outline-secondary" @click="openPositionDialog($refs.timeAndMaterialDialog)"
                            v-if="invoice.project && invoice.project.type === 'timeandmaterial'"
                        >
                            <font-awesome-icon icon="plus-circle" class="icon mb-1"/> Stunden auswählen
                        </b-button>
                    </div>
                </div>

                <invoice-position-dialog @save="addNewPosition" :project="invoice.project" ref="defaultInvoicePositionDialog"></invoice-position-dialog>
                <t-a-m-position-dialog @save="addNewPosition" :project="invoice.project" ref="timeAndMaterialDialog"></t-a-m-position-dialog>

                <v-client-table :data="invoicePositions" :columns="columns" :options="options" class="invoice-table mt-3">

                    <span slot="dateFrom" slot-scope="props" class="text-darker">{{props.row.dateFrom | moment('DD.MM.YYYY')}}</span>
                    <span slot="dateTo" slot-scope="props" class="text-darker">{{props.row.dateTo | moment('DD.MM.YYYY')}}</span>

                </v-client-table>

                <div class="row no-gutters">
                    <div class="col-3 offset-9 pt-4 text-darker">
                        <div class="d-flex">
                            <div class="text-exposed">Betrag:</div> <div class="flex-grow-1 text-right pr-2">{{calculatedAmout}}</div>
                        </div>
                        <div class="d-flex">
                            <div class="text-exposed">Ust:</div> <div class="flex-grow-1 text-right pr-2">{{calculatedVat}}</div>
                        </div>
                        <div class="d-flex mt-3">
                            <div class="text-exposed">Gesamtbetrag:</div>
                            <div class="flex-grow-1 text-right">
                                <span class="invoice-sum pt-1 pb-1 pl-2 pr-2">{{calculatedAmout + calculatedVat}}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-bottom-buttons d-flex justify-content-end mt-5">
                    <button type="submit" class="btn btn-success">Erstellen</button>
                    <button type="button" class="btn btn-link" @click="$router.go(-1)">Abbrechen</button>
                </div>
            </form>
            </div>
        </div>
    </div></div>
</template>

<script>
    import ModuleHeader from "components/util/ModuleHeader";
    import firestore from "firedb/init";
    import db from 'firedb/db';
    import firebase from 'firebase/app';
    import LoginState from 'components/auth/LoginState'; //TODO temp
    import Datepicker from 'vuejs-datepicker';
    import * as lang from "vuejs-datepicker/src/locale";
    import InvoicePositionDialog from   'components/invoice/InvoicePositionDialog';
    import TAMPositionDialog from 'components/invoice/time-and-material/TAMPositionDialog';

    export default {
        name: "InvoiceCreate",

        components: {ModuleHeader, Datepicker, InvoicePositionDialog, TAMPositionDialog},

        data: function() {

            return {
                invoice: {
                    number: null, //https://vuejs.org/2016/02/06/common-gotchas/ Why isn’t the DOM updating? 1
                    project: null,
                    customer: null,
                },
                invoicePositions: [],
                newInvoicePosition: {
                    work: null,
                    amount: 1,
                    price: null,
                    dateFrom: null,
                    dateTo: null
                },
                saveError: null,
                error: null,
                projects: null,
                customers: null,
                invoices: null,
                languages: lang,
                columns: ['work', 'dateFrom', 'dateTo', 'amount', 'price'],
                options: {
                    skin: 'table data-table',
                    filterable: false,
                    headings: {
                        work: 'Leistung',
                        dateFrom: 'Von',
                        dateTo: 'Bis',
                        amount: 'Menge',
                        price: 'Preis'
                    },
                },
            }
        },

        watch: {

            'invoice.customerId': function() {
                this.invoice.project = null;
            }
        },
        methods: {

            openPositionDialog(ref) {

                ref.openDialog();
            },

            //TODO mixin
            checkState(fieldName) {

                if (!this.errors.has(fieldName)) {
                    return null;
                }

                return false;
            },
            removeInvoicePosition() {

            },

            addNewPosition(position) {

                if (Array.isArray(position)) {
                    this.invoicePositions = this.invoicePositions.concat(position);
                } else {
                    this.invoicePositions.push(position);
                }
            },

            sendToFirebase() {

                const customer = this.customers.filter(x => x.id === this.invoice.customerId)[0];
                const projectName = this.projects.filter(x => x.id === this.invoice.project.id)[0].name;

                const invoice = {
                    number: this.invoice.number,
                    customerId: this.invoice.customerId,
                    projectId: this.invoice.project.id,
                    customerName: customer.name,
                    customerStreet: customer.street || '',
                    customerCity: customer.city || '',
                    customerZip: customer.zip || '',
                    customerVatId: customer.vatId || '',
                    projectName:  projectName,
                    state: 'created',
                    version: 1,
                    issuingCompany: Object.assign({}, LoginState.company),
                    positions: this.invoicePositions,
                    user: {
                        email: firebase.auth().currentUser.email,
                        uid: firebase.auth().currentUser.uid
                    },
                    createDate: this.$moment().format(),
                    updateDate: null
                };

                invoice.history = [Object.assign({}, invoice)];

                return db.create('invoice', invoice);
                //return firestore.collection('invoice').add(invoice);
            },
            createInvoice() {

                //TODO better validation!!!
                if (this.invoice.number && this.invoice.number.trim() !== '' && this.invoice.customerId && this.invoice.project) {
                    this.sendToFirebase().then(result => {

                        if (this.invoice.project.type === 'fixedprice') {
                            this.invoice.project.billedamount = this.calculatedAmout;
                            firestore.collection('project').doc(this.invoice.project.id).set(this.invoice.project);
                        }
                        this.$router.replace('/app/invoice');
                    }).catch(e => {
                        console.error(e);
                        this.saveError = "Rechnung konnte nicht erstellt werden."
                    });
                }
            },

            getInvoiceNumber(prefix) {

                if (this.invoices) {
                    return this.invoices.filter(x => {
                        return x.number.indexOf(prefix) !== -1;
                    }).length + 1;
                } else {
                    return 1;
                }
            }
        },

        computed: {

            calculatedAmout() {

                return this.invoicePositions.map(data => {

                    if (data.amount && data.price) {
                        return data.amount * data.price;
                    } else {
                        return 0;
                    }
                }).reduce((a, b) => {
                    return a + b;
                }, 0);
            },

            calculatedVat() {
                return Math.round(this.calculatedAmout * 0.2);
            }
        },
        created() {

            //TODO change to Promise.all
            firestore.collection('customer').get()
                .then(snapshot => {

                    if (snapshot.size === 0) {
                        return Promise.reject('Keine Kunden gefunden');
                    }

                    this.customers = [];

                    snapshot.forEach(doc => {
                        let customer = doc.data();
                        customer.id = doc.id;

                        this.customers.push(customer);
                    });
                })
                .then(() => {

                    return firestore.collection('project').get()
                        .then(snapshot => {

                            if (snapshot.size === 0) {
                                return Promise.reject('Keine Projekte gefunden');
                            }

                            this.projects = [];

                            snapshot.forEach(doc => {
                                let project = doc.data();
                                project.id = doc.id;

                                this.projects.push(project);
                            });
                        });
                })
                .then(() => {

                    return firestore.collection('invoice').get()
                        .then(snapshot => {

                            this.invoices = [];

                            snapshot.forEach(doc => {
                                let invoice = doc.data();
                                invoice.id = doc.id;

                                this.invoices.push(invoice);
                            });
                        });
                })
                .then(() => {
                    const date = new Date();
                    const numberPrefix = `${date.getFullYear()}-${date.getMonth() + 1}`;
                    this.invoice.number = `${numberPrefix}-${this.getInvoiceNumber(numberPrefix)}`;
                })
                .catch((e) => {
                    console.error(e);
                    this.error = 'Für die Erstelleung einer Rechnung notwendige Daten konnten nicht geladen werden.'
                });
        }

    }
</script>

<style scoped lang="css">

    .invoice-sum {

        background-color: #74808A;
        color: white;
        border-radius: 4px;
        font-weight: bold;
    }
</style>

<style>
    .invoice-table .VuePagination__count {
        display: none;
    }

    .invoice-table .VueTables__no-results {
        display: none;
    }
</style>